import { HttpError } from '../../config/Axios/axios-instance';
import { TextTemplate } from '../../domain/TextTemplate';
import { TextTemplateActionTypes } from './actionTypes';
import * as actionTypes from './actionTypes';

export type TextTemplateStateType = {
  textTemplatesListLaoding: boolean;
  textTemplatesList: TextTemplate[];
  textTemplatesListError: HttpError;
  createdTextTemplate: TextTemplate | null;
  textTemplateCreateLoading: boolean;
  textTemplateCreateError: HttpError;
  textTemplateCreateSuccess: boolean;
  textTemplateUpdateLoading: boolean;
  textTemplateUpdateError: HttpError;
  textTemplateUpdateSuccess: boolean;
  textTemplateDeleteLoading: boolean;
  textTemplateDeleteError: HttpError;
  textTemplateDeleteSuccess: boolean;
  textTemplateDuplicateLoading: boolean;
  textTemplateDuplicateError: HttpError;
  textTemplateDuplicateSuccess: boolean;
};

export type TextTemplateActionType = TextTemplateStateType & {
  type: TextTemplateActionTypes;
};

export const initialState: TextTemplateStateType = {
  textTemplatesListLaoding: false,
  textTemplatesList: [],
  textTemplatesListError: null,
  createdTextTemplate: null,
  textTemplateCreateError: null,
  textTemplateCreateLoading: false,
  textTemplateCreateSuccess: false,
  textTemplateUpdateError: null,
  textTemplateUpdateLoading: false,
  textTemplateUpdateSuccess: false,
  textTemplateDeleteLoading: false,
  textTemplateDeleteError: null,
  textTemplateDeleteSuccess: false,
  textTemplateDuplicateError: null,
  textTemplateDuplicateLoading: false,
  textTemplateDuplicateSuccess: false,
};

const fetchTextTemplatesStart = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplatesListLaoding: true,
  textTemplateCreateSuccess: false,
});

const fetchTextTemplatesSuccess = (
  state: TextTemplateStateType,
  action: TextTemplateActionType,
): TextTemplateStateType => ({
  ...state,
  textTemplatesListLaoding: false,
  textTemplatesList: [...state.textTemplatesList, ...action.textTemplatesList],
});

const fetchTextTemplatesFail = (
  state: TextTemplateStateType,
  action: TextTemplateActionType,
): TextTemplateStateType => ({
  ...state,
  textTemplatesListError: action.textTemplatesListError,
});

const createTextTemplateStart = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateCreateLoading: true,
});

const createTextTemplateSuccess = (
  state: TextTemplateStateType,
  action: TextTemplateActionType,
): TextTemplateStateType => ({
  ...state,
  textTemplateCreateLoading: false,
  textTemplateCreateError: null,
  textTemplateCreateSuccess: true,
  createdTextTemplate: action.createdTextTemplate,
});

const createTextTemplateFail = (
  state: TextTemplateStateType,
  action: TextTemplateActionType,
): TextTemplateStateType => ({
  ...state,
  textTemplateCreateLoading: false,
  textTemplateCreateError: action.textTemplateCreateError,
});

const updateTextTemplateStart = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateUpdateLoading: true,
});

const updateTextTemplateSuccess = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateUpdateLoading: false,
  textTemplateUpdateError: null,
  textTemplateUpdateSuccess: true,
});

const updateTextTemplateFail = (
  state: TextTemplateStateType,
  action: TextTemplateActionType,
): TextTemplateStateType => ({
  ...state,
  textTemplateUpdateLoading: false,
  textTemplateUpdateError: action.textTemplateUpdateError,
});

const deleteTextTemplateStart = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateDeleteLoading: true,
});

const deleteTextTemplateSuccess = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateDeleteLoading: false,
  textTemplateDeleteError: null,
  textTemplateDeleteSuccess: true,
});

const deleteTextTemplateFail = (
  state: TextTemplateStateType,
  action: TextTemplateActionType,
): TextTemplateStateType => ({
  ...state,
  textTemplateDeleteError: action.textTemplateDeleteError,
  textTemplateDeleteLoading: false,
});

const duplicateTextTemplateStart = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateDuplicateLoading: true,
});

const duplicateTextTemplateSuccess = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateDuplicateLoading: false,
  textTemplateDuplicateError: null,
  textTemplateDuplicateSuccess: true,
});

const duplicateTextTemplateFail = (
  state: TextTemplateStateType,
  action: TextTemplateActionType,
): TextTemplateStateType => ({
  ...state,
  textTemplateDuplicateLoading: false,
  textTemplateDuplicateError: action.textTemplateDuplicateError,
});

const resetTextTemplateStore = (): TextTemplateStateType => ({
  ...initialState,
});

const resetTextTemplateCreateStore = (
  state: TextTemplateStateType,
): TextTemplateStateType => ({
  ...state,
  textTemplateCreateLoading: false,
  textTemplateCreateSuccess: false,
  textTemplateCreateError: null,
  createdTextTemplate: null,
  // textTemplatesList: [],
});

const completelyResetTextTemplateStore = (): TextTemplateStateType => ({
  ...initialState,
});

const reducer = (state = initialState, action: TextTemplateActionType) => {
  switch (action.type) {
    case actionTypes.FETCH_TEXT_TEMPLATES_START:
      return fetchTextTemplatesStart(state);
    case actionTypes.FETCH_TEXT_TEMPLATES_SUCCESS:
      return fetchTextTemplatesSuccess(state, action);
    case actionTypes.FETCH_TEXT_TEMPLATES_FAIL:
      return fetchTextTemplatesFail(state, action);
    case actionTypes.CREATE_TEXT_TEMPLATE_START:
      return createTextTemplateStart(state);
    case actionTypes.CREATE_TEXT_TEMPLATE_SUCCESS:
      return createTextTemplateSuccess(state, action);
    case actionTypes.CREATE_TEXT_TEMPLATE_FAIL:
      return createTextTemplateFail(state, action);
    case actionTypes.UPDATE_TEXT_TEMPLATE_START:
      return updateTextTemplateStart(state);
    case actionTypes.UPDATE_TEXT_TEMPLATE_SUCCESS:
      return updateTextTemplateSuccess(state);
    case actionTypes.UPDATE_TEXT_TEMPLATE_FAIL:
      return updateTextTemplateFail(state, action);
    case actionTypes.DELETE_TEXT_TEMPLATE_START:
      return deleteTextTemplateStart(state);
    case actionTypes.DELETE_TEXT_TEMPLATE_SUCCESS:
      return deleteTextTemplateSuccess(state);
    case actionTypes.DELETE_TEXT_TEMPLATE_FAIL:
      return deleteTextTemplateFail(state, action);
    case actionTypes.DUPLICATE_TEXT_TEMPLATE_START:
      return duplicateTextTemplateStart(state);
    case actionTypes.DUPLICATE_TEXT_TEMPLATE_SUCCESS:
      return duplicateTextTemplateSuccess(state);
    case actionTypes.DUPLICATE_TEXT_TEMPLATE_FAIL:
      return duplicateTextTemplateFail(state, action);
    case actionTypes.RESET_TEXT_TEMPLATE_STORE:
      return resetTextTemplateStore();
    case actionTypes.RESET_TEXT_TEMPLATE_CREATE_STORE:
      return resetTextTemplateCreateStore(state);
    case actionTypes.LOGOUT:
      return completelyResetTextTemplateStore();
    default:
      return state;
  }
};

export default reducer;
